import React, { useEffect } from 'react';
import { ColorPicker, useColor } from 'react-color-palette';
import 'react-color-palette/css';

const ColorPalette = ({ value, getColor }) => {
  const [color, setColor] = useColor('#123123');

  useEffect(() => {
    getColor(color.hex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [color]);

  return (
    <ColorPicker
      color={color}
      onChange={setColor}
      hideAlpha
      hideInput={['rgb', 'hsv']}
    />
  );
};

export default ColorPalette;
